import type { EntityConfig } from "../hooks/useEntity";

export const uploadedDocumentEntityConfig: EntityConfig = {
  name: "UploadedDocument",
  orderBy: "created_at DESC",
  properties: {
    fileName: { type: "string", description: "Original file name" },
    fileType: {
      type: "string",
      enum: ["text", "pdf", "docx", "doc", "xlsx", "pptx", "html", "rtf", "unknown"],
      description: "Type of uploaded file",
    },
    rawContent: { type: "string", description: "Extracted plain text content" },
    documentCategory: {
      type: "string",
      enum: ["research_paper", "book_chapter", "lecture_notes", "article", "thesis", "report", "other"],
      description: "Categorized document type",
    },
    categoryConfidence: { type: "number", description: "Confidence score for category (0-100)" },
    detectedCitations: { type: "string", description: "JSON array of detected citations" },
    citationCount: { type: "integer", description: "Total number of citations detected" },
    keyPhrases: { type: "string", description: "JSON array of key phrases extracted" },
    documentSummary: { type: "string", description: "AI-generated summary of document content" },
    wordCount: { type: "integer", description: "Word count of extracted content" },
    pageCount: { type: "integer", description: "Approximate page count" },
    detectedLanguage: { type: "string", description: "Detected document language" },
    bookmarks: { type: "string", description: "JSON array of bookmarked sections" },
    notes: { type: "string", description: "User notes about the document" },
    importStatus: {
      type: "string",
      enum: ["success", "partial", "failed"],
      default: "success",
      description: "Status of file import",
    },
    userId: { type: "integer", description: "ID of user who uploaded the document" },
    documentId: { type: "integer", description: "Optional: ID of associated document" },
  },
  required: ["fileName", "fileType", "rawContent", "userId"],
};
